import './components/App.css';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <div>
    <Header />
    <Navbar />
    {/* <Home /> */}
    <Footer />

    </div>
  );
}

export default App;